import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { login } from '../redux/actions/auth'; // Importe a ação de login
import '../style/login.css'; // Importe seu arquivo de estilo
import menuLogo from "../assets/imagens/pentalobe.png";

const CadastroUser = () => {

    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation(); // Captura a rota de origem, se houver
    // const { error, code } = useSelector((state) => state.auth);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const credentials = { email, password };
        try {
            // Despacha a ação de login e "desembrulha" o payload
            const resp = await dispatch(login(credentials)).unwrap();

            if (resp.code === 200) {
                console.log(location.state, 'location')
                const redirectTo = location.state?.from?.pathname || (resp.profile === 'admin' ? '/index' : '/dashboard');
                // console.log(redirectTo,'redirectTo')
                navigate(redirectTo, { replace: true });
                // navigate('/index');
            }

        } catch (error) {
            setErrorMessage(error.message || 'Erro ao fazer login. Por favor, tente novamente.');
        }
    };

    return (
        <Container fluid>
            <Row className='d-flex justify-content-center align-items-center login-container'>
                <Col lg={4} className='login-form'>
                    <a href='/'><img className="logo-menu-login mb-3" src={menuLogo} alt="fundo-imagem-home" /></a>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formEmail">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder='Nome'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder='Email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="formPassword">
                            <Form.Label >Senha</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder='senha'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Group>

                        {errorMessage && <Alert variant="danger" className='mt-3 text-center'>{errorMessage}</Alert>}

                        <div className='text-center'>
                            <Button variant="primary" type="submit" className='mt-3'>
                                Entrar
                            </Button>
                        </div>

                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default CadastroUser;
